
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/snerapport",
      function () {
        return require("private-next-pages/snerapport.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/snerapport"])
      });
    }
  